<div class="login">
  <header class="login__header">
    <div class="login__header-container">
      <span class="login__brand">
        <i class="fas fa-dollar-sign"></i>ogivendas
      </span>
    </div>
  </header>

  <div class="login__container">
    <div class="login__header-content">
      <h1 class="login__title">Login</h1>
      <p class="login__subtitle">Faça login em sua conta para acessar o sistema</p>
    </div>

    <form
      [formGroup]="loginForm"
      class="login__form"
      novalidate
      (ngSubmit)="login()"
    >
      <div class="login__form-group">
        <label class="login__label" for="email">E-mail</label>
        <input
          type="email"
          class="login__input"
          formControlName="email"
          id="email"
          placeholder="ex: usuario@email.com"
          [class.login__input--invalid]="loginForm.get('email').touched && loginForm.get('email').invalid"
          sgtLowercase
        />
        <small
          class="login__field-error"
          *ngIf="loginForm.get('email').touched && loginForm.get('email').errors"
        >
          <span *ngIf="loginForm.get('email').errors['required']">E-mail é obrigatório</span>
          <span *ngIf="loginForm.get('email').errors['email']">E-mail inválido</span>
        </small>
      </div>

      <div class="login__form-group">
        <label class="login__label" for="senha">Senha</label>
        <div class="login__password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="login__input login__input--password"
            formControlName="senha"
            id="senha"
            placeholder="Digite sua senha"
            [class.login__input--invalid]="loginForm.get('senha').touched && loginForm.get('senha').invalid"
          />
          <button
            type="button"
            class="login__password-toggle"
            (click)="togglePasswordVisibility()"
            tabindex="-1"
          >
            <i
              class="fas"
              [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
            ></i>
          </button>
        </div>
        <small
          class="login__field-error"
          *ngIf="loginForm.get('senha').touched && loginForm.get('senha').errors"
        >
          <span *ngIf="loginForm.get('senha').errors['required']">Senha é obrigatória</span>
          <span *ngIf="loginForm.get('senha').errors['minlength']">A senha deve ter no mínimo 3 caracteres</span>
        </small>
      </div>

      <div class="login__actions">
        <div class="login__stay-connected">
          <input
            type="checkbox"
            formControlName="stayConnected"
            id="stayConnected"
          />
          <label for="stayConnected">
            Me manter conectado
          </label>
        </div>
      </div>

      <div class="login__btn-container">
        <button type="submit" class="login__btn" [disabled]="isLoading">
          <i *ngIf="isLoading" class="fas fa-spinner fa-spin login__btn-spinner" aria-hidden="true"></i>
          {{ isLoading ? 'Entrando...' : 'Entrar' }}
        </button>
      </div>
    </form>
  </div>
</div>
